import hopTimusAvatar from '@/hoc/HopTimusButton/hoptimus-avatar.png'
import IconWindowCollapse from '@/shared/icons/NewDesign/IconWindowCollapse'
import IconWindowExpand from '@/shared/icons/NewDesign/IconWindowExpand'
import useHopTimusDock from './useHopTimusDock'
import {
  DockAvatar,
  DockContent,
  DockMessage,
  DockSwitchButton,
  HopTimusDockFrame,
  PulseFrame,
} from './styled-components'

const HopTimusDock = () => {
  const {
    hidden,
    mode,
    closingFrom,
    layout,
    closing,
    afterFold,
    onFrameAnimationEnd,
    floating,
    ready,
    failed,
    url,
    frameRef,
    onFrameLoad,
    title,
    message,
    switchLabel,
    onSwitch,
  } = useHopTimusDock()

  if (hidden) return null

  return (
    <HopTimusDockFrame
      $mode={mode}
      $closingFrom={closingFrom}
      $afterFold={afterFold}
      onAnimationEnd={onFrameAnimationEnd}
    >
      <DockContent $layout={layout} $closing={closing} $afterFold={afterFold}>
        {ready && url ? (
          <>
            <PulseFrame
              ref={frameRef}
              src={url}
              title={title}
              onLoad={onFrameLoad}
              allow='clipboard-write'
              sandbox='allow-scripts allow-same-origin allow-forms allow-popups'
            />
            <DockSwitchButton type='button' aria-label={switchLabel} title={switchLabel} onClick={onSwitch}>
              {floating ? <IconWindowExpand size={18} /> : <IconWindowCollapse size={18} />}
            </DockSwitchButton>
          </>
        ) : (
          <DockMessage role={failed ? 'alert' : 'status'}>
            <DockAvatar src={hopTimusAvatar} alt='' />
            {message}
          </DockMessage>
        )}
      </DockContent>
    </HopTimusDockFrame>
  )
}

export default HopTimusDock
